export default __webpack_public_path__ + "static/media/bg12.0eaa224b.jpg";